import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { UserProfileProps } from "../types";
import UserProfileDetailsComponent from "./UserProfileDetails";
import UserAvatar from "./UserAvatar";
import UserMenu from "./UserMenu";
import { UserProfileContainer } from "./styled";
import { defaultMappedRole } from "../../../config/schoolConfig";

const UserProfile = ({
  anchorEl,
  handleMenuOpen,
  handleMenuClose,
}: UserProfileProps) => {
  const { user: loggedInUser } = useSelector(
    (state: RootState) => state.profile
  );

  return (
    <UserProfileContainer>
      <UserProfileDetailsComponent
        name={loggedInUser?.name}
        role={defaultMappedRole[loggedInUser?.role] || ""}
      />
      <UserAvatar
        profile={loggedInUser?.profile}
        name={loggedInUser?.name}
        onClick={handleMenuOpen}
      />
      <UserMenu
        anchorEl={anchorEl}
        onClose={handleMenuClose}
        signOutLabel="Logout"
      />
    </UserProfileContainer>
  );
};

export default UserProfile;
